import React from 'react'

import './FormPanel.scss'

interface FormPanelProps {
  readonly children: React.ReactNode
}

const FormPanel: React.FC<FormPanelProps> = ({ children }) => (
  <div className="FormPanel">
    <div className="FormPanel__container">
      {children}
    </div>
  </div>
)

export default FormPanel
